import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6 mb-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_img = _resolveComponent("v-img")
  const _component_v_card_title = _resolveComponent("v-card-title")
  const _component_v_select = _resolveComponent("v-select")
  const _component_v_card_text = _resolveComponent("v-card-text")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_card_actions = _resolveComponent("v-card-actions")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_snackbar = _resolveComponent("v-snackbar")
  const _component_v_container = _resolveComponent("v-container")

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "fill-height",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.merchandiseItems, (item) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: item.id,
              cols: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  "max-width": "350",
                  class: "pa-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: require(`../assets/${item.image}`),
                      "max-width": "300",
                      class: "mx-auto"
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card_title, { class: "text-center merch-title" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_text, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_1, "£" + _toDisplayString(item.price.toFixed(2)), 1),
                        _createVNode(_component_v_select, {
                          modelValue: $data.selectedSizes[item.id],
                          "onUpdate:modelValue": $event => (($data.selectedSizes[item.id]) = $event),
                          items: item.sizes,
                          label: "Size",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: !$data.selectedSizes[item.id],
                          color: "primary",
                          onClick: $event => ($options.addToCart(item))
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode(" Add to Cart ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: $data.showAddedSnackbar,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.showAddedSnackbar) = $event)),
        timeout: "2000"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Added to cart ", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}